// eslint-disable-next-line import/no-unresolved
import configFile from 'static:./config.json'

import type { ConnectwareAdminWebAppConfig } from '../config'

export default fetch(configFile).then<ConnectwareAdminWebAppConfig>((r) => r.json())
